export const useRememberTab = (tab: Ref<number>, query?: string) => {
    // use query parameter
    const router = useRouter();
    if (query == null) {
        // location
        watch(tab, si => {
            router.replace({ hash: '#' + si.toString() });
        });

        watch(
            () => router.currentRoute.value?.hash,
            hash => {
                if (hash == null) return;
                const tabHash = Number.parseInt(hash.substring(1));
                if (Number.isNaN(tabHash)) {
                    return;
                }
                tab.value = tabHash;
            },
            { immediate: true },
        );
    } else {
        watch(tab, si => {
            router.replace({ query: { ...router.currentRoute.value.query, [query]: si } });
        });

        watch(
            () => router.currentRoute.value?.query?.[query],
            si => {
                if (si == null) return;
                const tabHash = Number.parseInt(si as string);
                if (Number.isNaN(tabHash)) {
                    return;
                }
                tab.value = tabHash;
            },
            { immediate: true },
        );
    }
};
